// Testimonial Auto-Slide Configuration
export const TESTIMONIAL_CONFIG = {
  // Auto-slide timing (in milliseconds)
  autoSlideInterval: 4000, // 4 seconds per slide
  
  // Progress bar update frequency (in milliseconds)
  progressUpdateInterval: 50, // Update every 50ms for smooth animation
  
  // Auto-slide behavior
  pauseOnHover: true, // Pause when user hovers over testimonial
  showProgressBar: true, // Show progress bar at top
  showSlideIndicators: true, // Show dot indicators
  showPlayPauseButton: true, // Show play/pause control
  showSlideCounter: true, // Show "1/6 testimonials"
  
  // Animation settings
  transitionDuration: 500, // CSS transition duration in ms
  
  // Auto-start behavior
  autoStart: true, // Start auto-sliding immediately
};